module.exports = __webpack_public_path__ + "img/icon_footer_fifa.98162ff6.png";